import { InspectorStatusEnum } from 'types';

export enum RemarksModalMode {
  ACCEPT_WITH_REMARKS = 'accept_with_remarks',
  REJECT = 'reject',
}

export interface IRemarksModalEventPayload {
  remarks: string;
  status: InspectorStatusEnum;
}
